<template lang="pug">
  .component-date-picker
    .input-group
      span(class="input-group-label")
        span(class="fa fa-calendar")
      input(class="date-picker input-group-field", :disabled="disabled", :value="initialDate", :placeholder="placeholder", @input="$emit('uplaksdjflkasj')")
      .input-group-button(v-if="ClearCb && !disabled")
        button.button(@click="ClearCb") X
      slot
</template>
<script type="text/babel">
  import 'foundation-datepicker'
  import 'foundation-datepicker/css/foundation-datepicker.css'

  export default {
    name: 'DatePicker',
    components: {},
    data() {
      return {}
    },
    destroyed() {
      const destroyFast = container => {
        const el = document.getElementsByClassName(container)
        while (el.length > 0) {
          el[0].remove()
        }
      }
      destroyFast('datepicker datepicker-dropdown dropdown-menu')
    },
    mounted() {
      var self = this
      $(this.$el).find('.date-picker').fdatepicker({
        format: this.format,
        pickTime: this.pickTime,
        closeButton: this.closeButton,
        onRender: function (date) {
          if (self.disabledFrom) {
            var now = new Date(self.disabledFrom)
            return date.valueOf() < now.valueOf() ? 'disabled' : ''
          }
        }
      }).trigger('change')
        .on('change', function () {
          var date = self.format === undefined ? this.value.split('-').reverse().join('-') : this.value
          self.$emit('input', date)
        })
    },
    props: {
      pickTime: {
        type: Boolean,
        default: false
      },
      closeButton: {
        type: Boolean,
        default: false
      },
      format: {
        type: String,
        default: 'yyyy-mm-dd'
      },
      placeholder: {
        type: String,
        default: ''
      },
      initialDate: {
        type: String,
      },
      disabledFrom: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      },
      value: {},
      ClearCb() {
        type: Function
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-date-picker

  //input
    padding: 0 1rem
</style>



// WEBPACK FOOTER //
// DatePicker.vue?159cfdae